import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form as FormikForm } from 'formik'
import * as Yup from 'yup'
import * as transform from '../../../lib/transform'
import Button from '../Button/Button'
import Text from '../Text/Text'
import Link from '../Link/Link'
import TextFieldFormik from '../Fields/TextFieldFormik'

export const CODE_FIELD_ID = 'CODE_FIELD_ID'

const INITIAL_VALUES = {
  code: ''
}

export const VALIDATION_MESSAGES = {
  code: {
    format: 'Código de autenticação inválido',
    required: 'Código de autenticação requerido'
  }
}

export const setAuthError = (hasError, setFieldError) => {
  if (!hasError) return false

  return setFieldError('code', VALIDATION_MESSAGES.code.format)
}

export const CODE_REGEX_VALIDATION = /^[0-9]{6}$/gi

export const CodeSchema = {
  code: Yup.string()
    .required(VALIDATION_MESSAGES.code.required)
    .matches(CODE_REGEX_VALIDATION, {
      excludeEmptyString: true,
      message: VALIDATION_MESSAGES.code.format
    })
}

export const AuthSchema = Yup.object().shape({
  ...CodeSchema
})

const AuthForm = (props) => {
  const { handleSubmit, back, error } = props

  return (
    <Formik
      enableReinitialize
      initialValues={INITIAL_VALUES}
      validationSchema={AuthSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid, setFieldError }) => {
        const disabled = isSubmitting || !isValid

        useEffect(() => {
          setAuthError(error?.hasError, setFieldError)
        }, [error?.hasError, isSubmitting])

        return (
          <FormikForm>
            <TextFieldFormik
              name="code"
              mask="authCode"
              label="Digite o código"
              transform={transform.removeSpacesTranformField}
            />

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '85%'
              }}
            >
              {back ? (
                <Link to={back}>
                  <Button
                    type="outlined_dark"
                    margin="12px 0 0"
                    buttonType="button"
                    width="160px"
                  >
                    <Text
                      font="custom"
                      color="gray"
                      variation="dark"
                      size="xs"
                      value="Voltar"
                      bold
                    />
                  </Button>
                </Link>
              ) : null}
              <Button
                type="secondary"
                margin="12px 0 0"
                buttonType="submit"
                disabled={disabled}
                width="160px"
              >
                <Text
                  font="custom"
                  color="white"
                  size="xs"
                  value="Confirmar"
                  bold
                />
              </Button>
            </div>
          </FormikForm>
        )
      }}
    </Formik>
  )
}

AuthForm.defaultProps = {
  handleSubmit: null,
  back: undefined,
  error: {
    hasError: false,
    messages: []
  }
}

AuthForm.propTypes = {
  handleSubmit: PropTypes.func,
  back: PropTypes.string,
  error: PropTypes.shape({
    hasError: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.string)
  })
}

export default AuthForm
